<template>
  <div>
    <v-dialog v-model="hasActiveItem" max-width="900px">
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="activeItem = null">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Booking Details</v-toolbar-title>
        </v-toolbar>
        <v-simple-table class="dialog-no-footer">
          <template v-slot:default>
            <tbody>
              <tr v-for="header in itemHeaders" :key="header.value">
                <td>{{ header.text }}</td>
                <td>{{ activeItem[header.value] }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-text-field
              v-model="phone"
              label="Enter Customer Number"
              type="tel"
            ></v-text-field>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save" :loading="sending"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-title>
      <v-btn color="primary" class="mr-4" @click="dialog = true" rounded>
        Send Link
      </v-btn>

      <v-spacer></v-spacer>
    </v-card-title>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="listItems"
        :loading="loading"
        :server-items-length="totalItems"
        :options.sync="options"
      >
        <template v-slot:item.action="{ item }">
          <v-btn text @click="viewItem(item)" class="mr-1">
            <v-icon small>remove_red_eye</v-icon> View
          </v-btn>
          <v-btn text @click="deleteItem(item)" color="red">
            <v-icon small>delete</v-icon> Delete
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { bookings as api } from "@/api";
export default {
  name: "List",
  data: () => ({
    loading: false,
    dialog: false,
    options: {},
    headers: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Name", value: "name" },
      { text: "Phone", value: "phone" },
      { text: "Email", value: "email" },
      { text: "Date", value: "date" },
      { text: "Time", value: "time" },
      { text: "Actions", value: "action", sortable: false },
    ],
    itemHeaders: [
      {
        text: "#",
        align: "left",
        sortable: false,
        value: "id",
      },
      { text: "Name", value: "name" },
      { text: "Phone", value: "phone" },
      { text: "Email", value: "email" },
      { text:"Preferred Contact", value: "preferred_contact"},
      { text: "Address", value: "address" },
      { text: "City", value: "city" },
      { text: "Zip", value: "zipcode" },
      { text: "Date", value: "date" },
      { text: "Time", value: "time" },
      {text: "Year", value:"year"},
      { text: "Model", value: "model" },
      { text: "Make", value: "make" },
      { text: "Vin", value: "vin" },
      {text:"Access Notes", value:"access_notes"},
      {text:"Vehicle Notes", value:"vehicle_notes"},
      {text:"Service Type", value:"service_type"},
      { text: "Warranty", value: "warranty" },
      { text: "Installation", value: "installation" },
      { text: "CC Payment", value: "ccpayment" },
    ],
    listItems: [],
    phone: "",
    sending: false,
    totalItems: 0,
    search: "",
    formTitle: "Send Link",
    activeItem: null,
  }),
  watch: {
    options: {
      handler() {
        this.getListItems();
      },
      deep: true,
    },
  },
  computed: {
    hasActiveItem() {
      return Boolean(this.activeItem);
    },
  },
  methods: {
    initialize() {
      this.getListItems();
    },
    close() {
      this.dialog = false;
    },
    async save() {
      try {
        if (this.phone && this.phone.toString().length >= 10) {
          this.sending = true;
          await api.sendGoogleForm(this.phone);
          this.sending = false;
          this.phone = "";
          alert("data Sent Seccessfully");
          this.close();
        }
      } catch (error) {
        this.sending = false;
        this.phone = "";
        alert("Please write Correct data");
        this.close();
      }
    },

    async getListItems() {
      const { page = 1, itemsPerPage = 10 } = this.options;
      this.loading = true;
      const response = await api.getListItems(itemsPerPage, page);
      this.totalItems = response.data.count;
      this.listItems = response.data.data;
      this.loading = false;
    },
    async viewItem(item) {
      try {
        const response = await api.getItem(item.id);
        this.activeItem = response.data.data;
      } catch (error) {
        this.$toast.error("Error Getting Battery");
      }
    },
    closeItem() {
      this.activeItem = null;
    },
    async deleteItem(item) {
      const confirm = await this.$alert.confirm(
        `Delete Broadcast List #${item.id} ?`
      );
      if (confirm && confirm.value === true) {
        try {
          await api.deleteItem([item.id]);
          this.$toast.success("Deleted Successfully");
          this.getListItems();
        } catch (error) {
          this.$toast.error("Error Deleting");
        }
      }
    },
  },
};
</script>